import { clientPortalApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { TanstackTableSearchParamsAdapter } from '@itm/shared-frontend/lib/utils';
import {
  TenantResponse,
  TenantBrandingResponse,
  TenantShortResponse,
  TenantSearchPagedResponse,
  CreateTenantDto,
  UpdateTenantDto,
  UpdateTenantBrandingModel,
  UpdateTenantProductDto,
  DomainResponse,
  CompaniesProductsCountDto,
} from 'src/types';

export const getTenantById = (tenantId: string, config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<TenantResponse>(`/api/v1/tenants/${tenantId}`, config);

export const updateTenant = (tenantId: string, data: UpdateTenantDto) =>
  clientPortalApi.patch<void>(`/api/v1/tenants/${tenantId}`, data);

export const deleteTenantById = (tenantId: string) => clientPortalApi.delete<void>(`/api/v1/tenants/${tenantId}`);

export const getTenantListSearch = (params: TanstackTableSearchParamsAdapter, config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<TenantSearchPagedResponse>('/api/v1/tenants/search', { ...config, params });

export const getTenantListAll = (config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<TenantShortResponse[]>('/api/v1/tenants/all', config);

export const getTenantDomainListAll = (config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<DomainResponse[]>('/api/v1/tenants/domains', config);

export const createTenant = (data: CreateTenantDto) => clientPortalApi.post<string>('/api/v1/tenants', data);

export const getTenantBrandingById = (tenantId: string, config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<TenantBrandingResponse>(`/api/v1/tenants/${tenantId}/branding`, config);

export const updateTenantBranding = (tenantId: string, data: UpdateTenantBrandingModel) =>
  clientPortalApi.patch<void>(`/api/v1/tenants/${tenantId}/branding`, data);

export const getTenantBranding = (config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<TenantBrandingResponse>('/api/v1/tenants/branding', config);

export const updateTenantLogo = (tenantId: string, formData: FormData, config: AxiosRequestConfig = {}) =>
  clientPortalApi.post<void>(`/api/v1/tenants/${tenantId}/logo`, formData, config);

export const updateTenantProduct = (tenantId: string, productId: string, data: UpdateTenantProductDto) =>
  clientPortalApi.patch<void>(`/api/v1/tenants/${tenantId}/products/${productId}`, data);

export const assignProductToTenant = (tenantId: string, productId: string) =>
  clientPortalApi.post<void>(`/api/v1/tenants/${tenantId}/products/${productId}/assign`);

export const removeProductFromTenant = (tenantId: string, productId: string) =>
  clientPortalApi.post<void>(`/api/v1/tenants/${tenantId}/products/${productId}/unassign`);

export const getTenantCompaniesProductsCount = (tenantId: string, config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<CompaniesProductsCountDto>('/api/v1/tenants/companies-products', {
    ...config,
    params: { tenantId },
  });
